export const ObjectConstants = {
  active: "active"
};

export const Selector = {
  accordionHeader: ".nw_2023_closing_without_lp-content-accordion-header",
  accordionArrow: ".nw_2023_closing_without_lp-content-accordion-header-arrow"
};
